import { Navigate, useLocation } from "react-router-dom";

import { isAuthenticated } from "@/lib/auth";

interface Props {
  children: React.ReactNode;
}

/**
 * Route guard — if no JWT in storage, redirect to /login and
 * remember where we were so login can send us back.
 */
export function ProtectedRoute({ children }: Props) {
  const location = useLocation();
  if (!isAuthenticated()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
